import { IconAward, IconMoney, IconRepeat, IconSpark, Text } from '@consumidor-positivo/aurora';

type BenefitItem = {
  slug: 'both' | 'miles' | 'cashback' | 'clear';
  icon: JSX.Element;
  title: JSX.Element;
  description: JSX.Element;
  buttonText: string;
};
export const benefitList: BenefitItem[] = [
  {
    slug: 'both',
    icon: <IconAward />,
    title: (
      <Text as="h5" variant="body-medium" variantDesk="body-large" weight="bold">
        Ver todos os cartões
      </Text>
    ),
    description: (
      <Text as="p" variant="body-small" variantDesk="body-medium" color="secondary">
        Confira nossos cartões de cashback e milhas para <strong>economizar em suas compras e viagens.</strong>
      </Text>
    ),
    buttonText: 'Ver todos os cartões',
  },
  {
    slug: 'miles',
    icon: <IconSpark />,
    title: (
      <Text as="h5" variant="body-medium" variantDesk="body-large" weight="bold">
        Cartões com milhas
      </Text>
    ),
    description: (
      <Text as="p" variant="body-small" variantDesk="body-medium" color="secondary">
        Você pode conferir nossos cartões de milhas para <strong>economizar em suas viagens.</strong>
      </Text>
    ),
    buttonText: 'Ver cartões com milhas',
  },
  {
    slug: 'cashback',
    icon: <IconMoney />,
    title: (
      <Text as="h5" variant="body-medium" variantDesk="body-large" weight="bold">
        Cartões com cashback
      </Text>
    ),
    description: (
      <Text as="p" variant="body-small" variantDesk="body-medium" color="secondary">
        Venha conferir nossos cartões de cashback para <strong>economizar em todas as compras</strong>.
      </Text>
    ),
    buttonText: 'Ver cartões com cashback',
  },
  {
    slug: 'clear',
    icon: <IconRepeat />,
    title: (
      <Text as="h5" variant="body-medium" variantDesk="body-large" weight="bold">
        Refaça quantas vezes quiser
      </Text>
    ),
    description: (
      <Text as="p" variant="body-small" variantDesk="body-medium" color="secondary">
        Você pode tentar novamente com <strong>respostas diferentes ou outro valor de gasto mensal</strong>.
      </Text>
    ),
    buttonText: 'Refazer quiz',
  },
];
